<template>
  <div class="catalog-page">
    <h1 class="mt-0 mb-2">Gem Pages</h1>
    <CatalogPages />
  </div>
</template>

<script>
import CatalogPages from './components/CatalogPages.vue';
export default {
  components: { CatalogPages },
};
</script>

<style lang="scss">
.catalog-page {
  padding: 24px;
}
</style>
